"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCatalogOrdered = void 0;
function isCatalogOrdered(catalog, orderedCatalogs) {
    return orderedCatalogs.some(ordered => {
        var _a;
        return ordered.id === catalog.id ||
            ((_a = ordered.variants) === null || _a === void 0 ? void 0 : _a.some(variant => variant.id === catalog.id));
    });
}
exports.isCatalogOrdered = isCatalogOrdered;
//# sourceMappingURL=isCatalogOrdered.js.map